// extracted by mini-css-extract-plugin
export default {"row":"Row_row__zYYa2","alignTop":"Row_alignTop__iR0rd"};